import { ThunkDispatch } from 'redux-thunk';
import { Auth } from '@jg/auth';
import { Action } from 'redux';
import makeRequest from '@jg/http-client';
import { appActions } from '..';
import { ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import {
  fetchFundraisingPagesRequestMade,
  fetchFundraisingPagesRequestSuccess,
  fetchFundraisingPagesRequestError,
} from '../actionCreators/apiActions';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import { IAppState } from '../../types/state.d';

const fetchFundraisingPages = (teamGuid?: string) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  _state: () => IAppState,
  auth: Auth,
) => {
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(fetchFundraisingPagesRequestMade());
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/eligibleFundraiserPages`,
      {
        timeoutInMs: config.frpAPITimeoutInMs,
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.GET_FUNDRAISING_PAGES);
    }
    const data = await response.json();
    dispatch(fetchFundraisingPagesRequestSuccess(data));
    if (data.length) {
      dispatch(appActions.selectFundraisingPage(data[0].fundraiserPageGuid));
    }
  } catch (error) {
    dispatch(fetchFundraisingPagesRequestError(error.message));
    redirectByResponseStatus(error.status);
  }
};

export default fetchFundraisingPages;
